
import React from 'react';
import { Button } from '@/components/ui/button';
import { User, Users, UserX } from 'lucide-react';

export type AuthFilter = 'all' | 'authenticated' | 'unauthenticated';

interface AuthFilterButtonsProps {
  selectedFilter: AuthFilter;
  setSelectedFilter: (filter: AuthFilter) => void;
}

const AUTH_FILTERS: { value: AuthFilter; label: string; icon: React.ReactNode }[] = [
  { value: 'all', label: 'All Users', icon: <Users className="h-4 w-4 mr-2" /> },
  { value: 'authenticated', label: 'Authenticated', icon: <User className="h-4 w-4 mr-2" /> },
  { value: 'unauthenticated', label: 'Unauthenticated', icon: <UserX className="h-4 w-4 mr-2" /> },
];

const AuthFilterButtons: React.FC<AuthFilterButtonsProps> = ({ selectedFilter, setSelectedFilter }) => {
  return (
    <div className="flex gap-2">
      {AUTH_FILTERS.map((filter) => (
        <Button
          key={filter.value}
          variant={selectedFilter === filter.value ? 'default' : 'outline'}
          onClick={() => setSelectedFilter(filter.value)}
          className="flex items-center"
          size="sm"
        >
          {filter.icon}
          {filter.label}
        </Button>
      ))}
    </div>
  );
};

export default AuthFilterButtons;
